import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {FontSizes, WINDOW_HEIGHT, isPhone, vs} from '@/Utils/Dimensions';
import {StyleSheet} from 'react-native';

const customStyles = StyleSheet.create({
  eachMoveWrapper: {
    borderColor: CCColors.Grey.Border,
    borderWidth: StyleSheet.hairlineWidth,
    backgroundColor: CCColors.White,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,
    justifyContent: 'center',
    // flexDirection: 'row',
    // flex: 1,
  },
  eachMoveWrapperSolve: {
    borderColor: CCColors.Grey.Border,
    borderWidth: StyleSheet.hairlineWidth,
    backgroundColor: CCColors.White,
    paddingHorizontal: 5,
    paddingVertical: 15,
    paddingBottom: 0,
    paddingTop: 0,

    justifyContent: 'center',
    // flexDirection: 'row',
    // flex: 1,
  },
  eachMoveWrapper1: {
    borderColor: CCColors.Grey.Border,
    borderWidth: StyleSheet.hairlineWidth,
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: CCColors.White,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,

    justifyContent: 'center',
    // flexDirection: 'row',
    // flex: 1,
  },
  eachMoveWrapper2: {
    borderColor: CCColors.Grey.Border,
    borderWidth: StyleSheet.hairlineWidth,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 12,
    borderBottomRightRadius: 0,
    backgroundColor: CCColors.White,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,

    justifyContent: 'center',
    // flexDirection: 'row',
    // flex: 1,
  },
  eachMoveInsideWrapper: {
    // margin: 15,
    marginTop: 15,
    flexDirection: 'row',
    // marginTop:15,
    // marginTop:15,
    // marginTop:15,
  },
  AnalysisRightComponentWrapper: {
    // borderColor: CCColors?.Primary?.Default,
    // borderWidth: 1,
    // borderRadius: 4,
    flex: 1,

    // maxHeight: '50%',
    // maxHeight: WINDOW_HEIGHT / 1.6,
    height: '92vh',
    width: '100%',
    // justifyContent: 'center',
    // alignItems: 'center',
    backgroundColor: CCColors.Dashboard.DashboardBackground,
  },
  AnalysisRightComponentWrapperMobile: {
    height: '100%',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  label: {
    fontSize: 18,
  },
  count: {
    fontSize: 18,
  },
  playerScore: {
    // flexDirection: 'column',
    // width: '100%',
    // height: '100%',
    flex: 1,
    // overflow: 'auto',
  },
  reviewShell: {
    height: '100%',
    backgroundColor: 'transparent',
    padding: 0,
    minWidth: 0,
  },
  reviewCard: {
    height: '100%',
    minHeight: 0,
    borderRadius: 16,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: 'rgba(77, 63, 55, 0.08)',
    shadowColor: '#4D3F37',
    shadowOpacity: 0.12,
    shadowRadius: 18,
    shadowOffset: {width: 0, height: 8},
  },
  reviewContent: {
    flex: 1,
    minHeight: 0,
  },
  reviewScene: {
    flex: 1,
    minHeight: 0,
    alignItems: 'stretch',
  },
  reviewSceneScroll: {
    flex: 1,
    minHeight: 0,
  },
  reviewTabBar: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 14,
    paddingTop: 6,
    paddingBottom: 0,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(77,63,55,0.10)',
  },
  reviewTab: {
    flex: 1,
    minHeight: 44,
    borderRadius: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 0,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
    backgroundColor: '#FFFFFF',
  },
  reviewTabActive: {
    borderBottomColor: '#3DAB9E',
    backgroundColor: '#FFFFFF',
  },
  reviewTabText: {
    fontSize: 13,
    fontWeight: '800',
    color: '#8F7A65',
  },
  reviewTabTextActive: {
    color: '#2F8E83',
  },
  reviewNavControls: {
    flexDirection: 'row',
    position: 'absolute',
    alignSelf: 'flex-end',
    right: 18,
    top: 74,
    zIndex: 1000,
    gap: 8,
  },
  reviewNavButton: {
    width: 34,
    height: 34,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FAF0D1',
    borderWidth: 1,
    borderColor: 'rgba(250, 207, 71, 0.75)',
  },
  reviewPanelBody: {
    width: '100%',
    flex: 1,
    minHeight: 0,
    paddingHorizontal: 14,
    paddingBottom: 12,
  },
  manualMovesPanel: {
    width: '100%',
    paddingHorizontal: 14,
    paddingTop: 8,
  },
  reviewSummary: {
    marginTop: vs(18),
    marginHorizontal: vs(18),
    width: '90%',
    backgroundColor: 'white',
    padding: vs(8),
    borderRadius: vs(8),
    shadowRadius: vs(2),
    shadowOpacity: 0.5,
    shadowColor: '#4D3F37',
  },
  reviewSummaryHeader: {
    letterSpacing: 2,
  },
  reviewSummaryDescription: {
    marginTop: vs(8),
    letterSpacing: 1,
    lineHeight: vs(18),
  },
  analysisStatusCard: {
    marginHorizontal: 0,
    marginTop: 0,
    marginBottom: 0,
    paddingHorizontal: 16,
    paddingTop: 14,
    paddingBottom: 12,
    borderRadius: 0,
    borderWidth: 0,
    backgroundColor: '#DDF8F2',
  },
  analysisStatusHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 9,
    marginBottom: 10,
  },
  analysisStatusTitleGroup: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 9,
    flexShrink: 1,
    minWidth: 0,
  },
  analysisStatusDot: {
    width: 9,
    height: 9,
    borderRadius: 5,
    backgroundColor: '#3DAB9E',
  },
  analysisStatusDotStopped: {
    backgroundColor: '#8F7A65',
  },
  analysisStatusTitle: {
    color: '#262322',
    fontSize: 13,
    fontWeight: '800',
    lineHeight: 17,
  },
  analysisStatusSub: {
    color: '#73695F',
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 16,
    flexShrink: 1,
    minWidth: 0,
    marginTop: 5,
  },
  analysisProgressTrack: {
    height: 5,
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: 'rgba(61,171,158,0.20)',
  },
  analysisProgressFill: {
    height: '100%',
    borderRadius: 6,
    backgroundColor: '#3DAB9E',
  },
  analysisRestartButton: {
    backgroundColor: '#3DAB9E',
    borderColor: '#3DAB9E',
    borderWidth: 1,
    borderRadius: 8,
  },
  analysisRestartButtonContent: {
    paddingHorizontal: 14,
    paddingVertical: 7,
  },
  analysisRestartButtonText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: '900',
  },
  reviewModeToggle: {
    flexDirection: 'row',
    padding: 3,
    borderRadius: 8,
    backgroundColor: '#FAF6EB',
  },
  reviewModeOption: {
    minWidth: 56,
    minHeight: 31,
    borderRadius: 7,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 9,
  },
  reviewModeOptionActive: {
    backgroundColor: '#FFFFFF',
  },
  reviewModeText: {
    color: '#73695F',
    fontSize: 12,
    fontWeight: '700',
  },
  reviewModeTextActive: {
    color: '#262322',
    fontWeight: '900',
  },
  positionsConfirmBody: {
    width: '100%',
    paddingHorizontal: 22,
    paddingTop: 20,
    paddingBottom: 18,
    backgroundColor: '#FFFFFF',
  },
  positionsConfirmModal: {
    width: 390,
    maxWidth: '90vw',
    minWidth: 0,
    borderRadius: 12,
    overflow: 'hidden',
  },
  positionsConfirmModalMobile: {
    width: '92vw',
    minWidth: 0,
    borderRadius: 12,
    overflow: 'hidden',
  },
  positionsConfirmModalBody: {
    flex: 0,
    padding: 0,
  },
  positionsConfirmHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 14,
  },
  positionsConfirmIcon: {
    width: 34,
    height: 34,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#DDF8F2',
    marginRight: 10,
  },
  positionsConfirmTitle: {
    color: '#262322',
    fontSize: 14,
    fontWeight: '900',
    lineHeight: 18,
  },
  positionsConfirmMessage: {
    color: '#73695F',
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 18,
  },
  positionsConfirmActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 18,
  },
  positionsConfirmCancelButton: {
    backgroundColor: '#FFFFFF',
    borderColor: 'rgba(77,63,55,0.18)',
    borderWidth: 1,
    borderRadius: 9,
  },
  positionsConfirmPrimaryButton: {
    backgroundColor: '#3DAB9E',
    borderColor: '#3DAB9E',
    borderWidth: 1,
    borderRadius: 9,
  },
  positionsConfirmButtonContent: {
    paddingHorizontal: 18,
    paddingVertical: 8,
  },
  positionsConfirmCancelText: {
    color: '#73695F',
    fontSize: 12,
    fontWeight: '800',
  },
  positionsConfirmPrimaryText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: '900',
  },
  playerScoreEach: {
    // flex: 0.2,
    // borderWidth: StyleSheet.hairlineWidth,
  },
  rightReviewTopHeader: {
    backgroundColor: CCColors?.White,
    padding: 10,
    paddingTop: 30,
    paddingBottom: 15,
    fontSize: FontSizes[12],
    color: CCColors?.Tabs.InactiveTabFont,
    minWidth: 100,
    textAlign: 'center',

    borderBottomColor: CCColors?.Primary.Default,
    borderBottomWidth: 3,
  },
  rightReviewTopHeaderMobile: {
    paddingVertical: 5,
  },
  rightReviewLeftHeader: {
    justifyContent: 'flex-start',
    // backgroundColor: CCColors?.Primary?.Default,
    padding: 10,
    width: '30%',
    color: CCColors?.White,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  selectedMove: {
    backgroundColor: CCColors.Primary.lightYellow,
    borderColor: CCColors.Primary.Default,
    borderWidth: StyleSheet.hairlineWidth,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    // backgroundColor: CCColors.White,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,
    justifyContent: 'center',
  },
  rightReviewTopHeaderSub: {
    backgroundColor: CCColors?.White,
    padding: 10,
    paddingTop: 30,
    paddingBottom: 15,
    fontSize: FontSizes[12],
    color: CCColors?.Tabs.InactiveTabFont,
    minWidth: 100,
    textAlign: 'center',
    // width: '33%',
  },
  rightReviewTopHeaderSubMobile: {
    paddingTop: 5,
  },
  rightReviewTopHeaderSubSub: {
    fontSize: FontSizes[3],
    height: 'fit-content',
  },
});
export default customStyles;
